import React from "react";
import { usePreferences } from "store/selectors/hooks";
import { Checkbox } from "../ui/checkbox";
import { useHasActiveSmtpCredential, useUserMailboxes } from "./use-user-mailboxes";

function useShouldShowBccMyself(): boolean {
    const { hasActiveMailbox } = useUserMailboxes();
    const hasActiveSmtpCredential = useHasActiveSmtpCredential();
    return !hasActiveMailbox && !hasActiveSmtpCredential;
}

export function useBccMyself(): {
    bccMyself: boolean;
    setBccMyself: (value: boolean) => void;
} {
    const userPreferences = usePreferences();
    const showBccMyself = useShouldShowBccMyself();
    const [bccMyself, setBccMyself] = React.useState(
        showBccMyself ? userPreferences.bccMyself : false,
    );
    return { bccMyself, setBccMyself };
}

interface BccMyselfCheckboxProps {
    bccMyself: boolean;
    onChange: (checked: boolean) => void;
}

export const BccMyselfCheckbox: React.FC<BccMyselfCheckboxProps> = ({
    bccMyself,
    onChange,
}) => {
    const showBccMyself = useShouldShowBccMyself();
    if (!showBccMyself) {
        return null;
    }
    return (
        <Checkbox
            label="BCC myself on this email"
            checked={bccMyself}
            onChange={e => onChange(e.target.checked)}
        />
    );
};
